import {
  Component,
  EventEmitter,
  input,
  OnInit,
  Output,
  effect,
  OnDestroy,
  signal,
} from "@angular/core";
import { interval, Subscription } from "rxjs";

@Component({
  selector: "app-auto-toogle",
  templateUrl: "./auto-toogle.component.html",
  styleUrl: "./auto-toogle.component.scss",
  standalone: false,
})
export class AutoToogleComponent implements OnInit, OnDestroy {
  isAutoLoadChecked = input<boolean>(false);
  // Local writable signal for template binding
  isAutoLoadCheckedLocal = signal<boolean>(false);

  @Output() isAutoLoadCheckedChange = new EventEmitter<boolean>();
  @Output() executeFunction: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  private autoLoadSubscription: Subscription | null = null;

  constructor() {
    // React to input signal changes and update local signal
    effect(() => {
      this.isAutoLoadCheckedLocal.set(this.isAutoLoadChecked());
      if (this.isAutoLoadChecked()) {
        this.startAutoLoad();
      } else {
        this.stopAutoLoad();
      }
    });
  }

  ngOnInit() {
    this.watchAutoLoadChanges();
  }

  ngOnDestroy() {
    this.stopAutoLoad();
    console.log("AutoToogleComponent destroyed, subscription cleaned up");
  }

  toggleAutoLoad(): void {
    this.isAutoLoadCheckedChange.emit(this.isAutoLoadCheckedLocal());
    if (this.isAutoLoadCheckedLocal()) {
      this.startAutoLoad();
    } else {
      this.stopAutoLoad();
    }
  }

  private watchAutoLoadChanges(): void {
    // Initial setup based on initial value
    if (this.isAutoLoadCheckedLocal()) {
      this.startAutoLoad();
    }
  }

  /**
   * Starts the auto-load interval that runs getMigrations every 10 seconds
   */
  private startAutoLoad(): void {
    // First stop any existing subscription to prevent duplicates
    this.stopAutoLoad();

    // Create a new interval subscription that runs every 10 seconds
    this.autoLoadSubscription = interval(60000).subscribe(() => {
      console.log("Auto-loading migrations...");
      this.executeFunction.emit(true);
    });
  }

  /**
   * Stops the auto-load interval if it's running
   */
  private stopAutoLoad(): void {
    if (this.autoLoadSubscription) {
      this.autoLoadSubscription.unsubscribe();
      this.autoLoadSubscription = null;
    }
  }
}
